import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import BottomNav from "./BottomNav";
import AppBar from "./AppBar";

function Interesting() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
  }));
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar />
      <br />
      <br />
      <br />
      <br />
      <Container>
        <div className={classes.root}>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography style={{ color: "#3f51b5" }}>
                How much do waiters earn in South Africa?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                The average waiter salary in South Africa is R 157 800 per year
                or R 80.92 per hour. Entry level positions start at R 126 000
                per year while most experienced workers make up to R 1 336 812
                per year.
                <br />
                <Link href="https://za.talent.com/salary?job=waiter">
                  Source: za.talent.com
                </Link>
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
            >
              <Typography style={{ color: "#3f51b5" }}>
                Tipping standards in South Africa
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                You're not obliged to leave a tip if the service provider was
                unprofessional, rude, intoxicated or has provided inadequate
                service, says Kane William Pretorius, Etiquette Consultant at
                The South African School of Etiquette in Sandton, Johannesburg.
                "For example, if you did not receive what you were promised in
                an acceptable time frame and there was no preemptive attempt to
                salvage the situation, you do not need to leave a tip," he says.
                <br />
                <br />
                Tip with cash, if you can, says Riandi Conradie, Founder of The
                South African Etiquette Academy. "Tipping by card is also
                appreciated, but the service staff member only receives it by
                the end of the week or month."
                <br />
                <Link href="https://www.capetownmagazine.com/tipping-south-africa">
                  Source: capetownmagazine
                </Link>
                <br />
                <br />
                <Typography variant="h6" gutterBottom>
                  Restaurants
                </Typography>
                Tipping is standard practice in South Africa to tip your waiter
                or waitress 10 to 20 % of the total bill. Most waiters and
                waitresses earn a minimum wage, but they do rely heavily on
                their tips to make a living. Some restaurants will automatically
                add a standard service charge of 10% too big groups, but check
                this with the manager. If a standard service charge is charged,
                it is up to the patron to decide whether or not to add to the
                tip depending on service.
                <br /> <br />
                <Typography variant="h6" gutterBottom>
                  Bars
                </Typography>
                Barmen and women also rely heavily on tips. Tipping them works
                the same as with restaurants, where 10 to 20 % is of the total
                bill is acceptable.
                <br />
                <Link href="https://safariguideafrica.com/tipping-advice-in-south-africa/#:~:text=Tipping%20is%20standard%20practice%20in,tips%20to%20make%20a%20living.">
                  Source: safariguideafrica
                </Link>
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
        <br /> <br /> <br />
      </Container>
      <BottomNav active={1} />
    </React.Fragment>
  );
}

export default Interesting;
